import React, { Component } from 'react'
import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Select } from '@driftt/tide-core-legacy'
import { inboxOptions } from 'app/modules/inbox/selectors'
import { bulkCloseForInbox } from 'app/modules/inbox/actions'

import './style.styl'

class BulkMessageActions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      selectedInboxId: props.inboxOptions[0].value,
    }
  }

  handleOnChange = ({ value }) => {
    this.setState({
      selectedInboxId: value,
    })
  }

  handleBulkClose = () => {
    this.setState(
      prevState => ({
        isLoading: !prevState.isLoading,
      }),
      () => this.props.actions.bulkCloseForInbox(this.state.selectedInboxId)
    )
  }

  render() {
    return (
      <div className="bulk-close-inbox-container">
        <div className="bulk-close-inbox-action-wrapper">
          <div className="bulk-close-inbox-selector-wrapper">
            <Select
              label="Inbox name"
              onChange={this.handleOnChange}
              options={this.props.inboxOptions}
              value={this.state.selectedInboxId}
            />
          </div>
          <div className="bulk-close-inbox-selector-button">
            <Button disabled={this.state.isLoading} onClick={this.handleBulkClose} type="danger">
              Close All Open Conversations
            </Button>
          </div>
        </div>
        <div className="bulk-close-inbox-warning-message">
          <h2>
            WARNING: Closing many open conversations within an inbox can lead to performance issues in the
            conversations view. It is recommended to perform this action during off-peak hours.
          </h2>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    inboxOptions: inboxOptions(state).toJS(),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        bulkCloseForInbox,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  branch(props => !props.inboxOptions.length, renderNothing)
)(BulkMessageActions)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/conversations/BulkMessageActions/index.js